function AccessSetting(can: any) {
  can("access", "Advance_Setting");
}

function ManageSetting(manageSetting: any, can: any) {
  if (manageSetting && manageSetting.setting) AccessSetting(can);
}
export { ManageSetting };
